import { CheckoutPagePreview } from "./CheckoutPagePreview";
import { MobileFixedOnTopPreview } from "./MobileFixedOnTopPreview";
import { OfferPagePreview } from "./OfferPagePreview";

export const ModalPreview = Object.assign(CheckoutPagePreview, {
  OfferPagePreview,
  CheckoutPagePreview,
  MobileFixedOnTopPreview,
});
